import { useNavigate } from 'react-router-dom';
import { NewBadge, Cover } from '../primitives';
import { localizedField } from '../../locales/content';
import { hapticImpact } from '../../utils/haptics';
import { getCardTitleImageWidth } from './titleImageSizing';

/**
 * PhotoPresetCard — карточка фото-пресета в горизонтальной карусели каталога.
 *
 * Figma source: photo-card в каталоге `318:4525` (catalog generate-image).
 * Aspect ratio 3:4 (handoff §7) — те же 160×240, что и у VideoPresetCard.
 *
 * Props:
 *   preset — { id, name, image, titleImage?, isNew }
 *
 * Tap → navigate('/prompt/' + preset.id) — переход на экран prompt'а для
 * конкретного шаблона (stage-03 routing). Catalog тем самым заменяет drill
 * через /group/:id для одиночного preset'а, что соответствует подходу
 * VideoCatalog.
 */
export default function PhotoPresetCard({ preset, onSelect, cardSize = 'M' }) {
  const navigate = useNavigate();

  if (!preset) return null;
  const name = localizedField(preset, 'name') || preset.name;
  const imageUrl = preset.image;
  const titleImage = preset.titleImage || preset.logoUrl || null;

  const handleTap = () => {
    hapticImpact('light');
    if (typeof onSelect === 'function') {
      onSelect(preset);
      return;
    }
    navigate(`/prompt/${preset.id}`);
  };

  return (
    <button
      type="button"
      onClick={handleTap}
      className="relative w-full rounded-home-16 overflow-hidden bg-surface-2 p-0 border-0"
      style={{ aspectRatio: '3 / 4' }}
      aria-label={name || 'Photo preset'}
      data-testid="photo-preset-card"
    >
      {imageUrl ? (
        <Cover
          coverUrl={imageUrl}
          alt={name || ''}
          className="!w-full !h-full !rounded-none"
        />
      ) : (
        <div className="absolute inset-0 bg-surface-2" />
      )}

      {preset.isNew && (
        <NewBadge coverRadius={16} className="absolute top-0 right-0 z-10" />
      )}
      {titleImage && (
        <img
          src={titleImage}
          alt=""
          className="absolute left-1/2 bottom-4 z-[2] h-auto max-w-full -translate-x-1/2 object-contain pointer-events-none"
          style={{ width: getCardTitleImageWidth(cardSize) }}
          loading="lazy"
          draggable={false}
        />
      )}
    </button>
  );
}
